export default "__VITE_ASSET__BSdgkB7E__"